/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { filesAPI } from 'src/api/modules/files';
import FileVersions from './FileVersions';
import { Button } from 'react-bootstrap';
import notice from 'src/common/components/Notice';
import { columnsRecord } from './utils/list_data';
import { startLog } from 'src/api/modules/bitacora';
import BaseModal from 'src/common/components/Modal';
import FullTable from 'src/common/components/FullTable';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { UploadFileMinos, download } from 'src/pages/Files/UpaloadFileMinos';

const AdditionalFiles = ({ open, setClose, dataSession, user }) => {
	const [files, setFiles] = useState([]);
	const [currentFile, setCurrentFile] = useState({});
	const [lastVersionFiles, setLastVersionFiles] = useState([]);
	const [loader, setLoader] = useState(false);
	const [fileVersionsModal, setFileVersionsModal] = useState(false);
	const [idFileDetail, setIdFileDetail] = useState();
	const [allFiles, setAllFile] = useState({});
	const [uniques, setUniques] = useState([]);
	const [offVersions, setOffVersions] = useState(false);
	const systemLevelRole = user?.organos[0].nombrePerfil.toUpperCase();
	const offShowDetail = ['ENLACE', 'CONSULTA'];
	let finalFiles = [];

	useEffect(() => {
		setCurrentFile({
			idEntidad: dataSession.id,
			title: 'Adicionales',
			entidad: 'SESION',
			tipo: 'A',
			ruta: 'Adicional/' + dataSession.id + '/',
			nombre: '',
		});

		if (dataSession.id !== undefined && open === true) getFiles();

		setOffVersions(offShowDetail.includes(systemLevelRole));
	}, [open]);

	const getFiles = () => {
		setAllFile([]);
		filesAPI
			.get('SESION', dataSession.id, false, 'A')
			.then((response) => {
				finalFiles = [];
				let filesActa = response.filter((e) => {
					return e.ruta.startsWith('Acta/');
				});
				validateFilesActa(filesActa);

				let numberedFiles = response.filter((e) => {
					return e.tipo === 'D' || e.ruta.startsWith('Adicional/');
				});

				validateNumberedFiles(numberedFiles);
			})
			.catch(() => {
				notice('Ha ocurrido un error al cargar archivos adicionales');
			});
	};

	const validateFilesActa = (filesActa) => {
		let uniquesNamesActa = [...new Set(filesActa.map((u) => u.nombre))];

		uniquesNamesActa.forEach(function (u) {
			let itemsFiles = filesActa.filter((e) => {
				return e.nombre === u;
			});

			let orderSL = itemsFiles.sort((b, a) => {
				return Number(b.id) - Number(a.id);
			});

			assignNumberFilesActa(orderSL);
		});
	};

	const assignNumberFilesActa = (data) => {
		let SigNum = 0;
		data.forEach((item) => {
			SigNum = SigNum + 1;
			finalFiles.push({
				...item,
				idFile: item.id,
				title: 'Acta',
				fecha: new Date(item.fecha).toLocaleDateString(),
				hora: new Date(item.fecha).toLocaleString().split(',')[1],
				nombreOriginal: item.nombre,
				nombreNumero: SigNum + '_' + item.nombre,
				numeroFile: SigNum,
			});
		});
		setFiles(finalFiles);
	};

	const validateNumberedFiles = (numberedFiles) => {
		numberedFiles.forEach((item) => {
			finalFiles.push({
				...item,
				idFile: item.id,
				title: 'Adicionales',
				fecha: new Date(item.fecha).toLocaleDateString(),
				hora: new Date(item.fecha).toLocaleString().split(',')[1],
				nombreOriginal: item.nombre.slice(item.nombre.indexOf('_') + 1),
				nombreNumero: item.nombre,
				numeroFile: Number(item.nombre.split('_')[0]),
			});
		});

		setFiles(finalFiles);
		let filesNumber = finalFiles.filter((e) => e.numeroFile === Number(e.numeroFile));

		let uniquesNames = [...new Set(filesNumber.map((u) => u.nombreOriginal))];

		getUpdateVersion(filesNumber, uniquesNames);
	};

	const getUpdateVersion = (finalFiles, uniquesNames) => {
		setUniques(uniquesNames);
		setAllFile(finalFiles);

		let ultimaVersionFiles = [];
		uniquesNames.forEach(function (u) {
			let itemsFiles = finalFiles.filter((e) => {
				return e.nombreOriginal === u;
			});

			let obtenermayor = itemsFiles.sort((a, b) => {
				return Number(b.numeroFile) - Number(a.numeroFile);
			});

			ultimaVersionFiles.push(obtenermayor[0]);
		});

		setLastVersionFiles(ultimaVersionFiles);
		setLoader(false);
	};

	const onUploadedFile = () => {
		setLoader(true);
		setUniques([]);
		getFiles();
	};

	const getId = () => {
		if (currentFile.idEntidad === undefined) {
			currentFile.idEntidad = 'undefined';
			return (
				'BtnuploadMinos' +
				currentFile.idEntidad.toString() +
				currentFile.title.replaceAll(' ', '')
			);
		}
		return (
			'BtnuploadMinos' +
			currentFile.idEntidad.toString() +
			currentFile.title.replaceAll(' ', '')
		);
	};

	const onDownload = (ruta) => {
		if (ruta.ruta !== undefined)
			download(
				ruta.ruta,
				ruta.nombre,
				user.nombre + ' ' + user.apellidoPaterno + ' ' + user.apellidoMaterno,
				setLoader,
				'adicionales, de la sesión ' + dataSession.numero_sesion,
				ruta.nombreOriginal
			);
	};

	const onEye = (row) => {
		setFileVersionsModal(true);
		setIdFileDetail(row.nombreOriginal);
		startLog(
			'Visualizo historial de versiones del archivo: ' + row.nombre.split('_')[1]
		);
	};

	const onDelete = (ruta) => {
		let mismoFile = allFiles.filter((e) => e.nombreOriginal === ruta.nombreOriginal);

		mismoFile.forEach((item, index) => {
			filesAPI
				.deleteFiles(item.idFile)
				.then(() => {
					if (index === mismoFile.length - 1) {
						notice('Archivo eliminado con exito', 'success');
						onUploadedFile();
					}
				})
				.catch((e) => {
					notice('Ha ocurrido un error al eliminar vesiones del archivo');
				});
		});
	};
	return (
		<BaseModal
			open={open}
			onClose={setClose}
			onCancel={setClose}
			maxWidth="lg"
			cancelLabel="cerrar"
			mainText="Archivos Adicionales"
		>
			{currentFile.idEntidad !== undefined ? (
				offVersions === false && (
					<UploadFileMinos
						control={
							<Button
								name="nombreFile"
								id={getId()}
								className="col-auto mr-auto btn btn-outline-primary btn-lg btn-block"
							>
								Cargar Nuevo Archivo
							</Button>
						}
						onUploaded={onUploadedFile}
						idEntidad={currentFile.idEntidad}
						tipo={currentFile.tipo}
						entidad={currentFile.entidad}
						ruta={currentFile.ruta}
						title={currentFile.title}
						nombre={currentFile.nombre}
						idFile={currentFile.id}
						setOpen={setLoader}
						firstFile={true}
						allFiles={allFiles}
						myFiles={allFiles}
					/>
				)
			) : (
				<></>
			)}
			{allFiles !== undefined && allFiles.length > 0 && (
				<FullTable
					items={lastVersionFiles}
					columns={columnsRecord(
						onUploadedFile,
						onDownload,
						onEye,
						allFiles,
						uniques,
						setLoader,
						offVersions,
						onDelete
					)}
				/>
			)}
			{
				<Backdrop open={loader} style={{ zIndex: 1 }}>
					<CircularProgress color="secondary" />
				</Backdrop>
			}
			{fileVersionsModal === true && (
				<FileVersions
					open={fileVersionsModal}
					setClose={() => {
						setFileVersionsModal(false);
					}}
					dataSession={dataSession}
					user={user}
					nameFileDetail={idFileDetail}
					currentFile={currentFile}
				/>
			)}
		</BaseModal>
	);
};

export default AdditionalFiles;
